import React, { useState } from 'react';

function FAQ({ question, answer }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <div className="w-full bg-white border border-gray-200 rounded-2xl shadow-sm mb-4 overflow-hidden transition-all duration-200 hover:shadow-md hover:border-[#FFD82D]">
      
      {/* Question Header (Full row is clickable button with large touch target) */}
      <button
        onClick={handleOpen}
        aria-expanded={open}
        className="flex justify-between items-center w-full text-left font-extrabold text-base sm:text-lg text-[#162E3B] py-5 px-6 sm:px-8 hover:bg-gray-50 transition-colors duration-150 focus:outline-none"
      >
        <span className="pr-4">{question}</span>
        
        {/* Large visual toggle symbol (+ or -) */}
        <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gray-100 text-[#162E3B] flex items-center justify-center font-bold text-lg sm:text-xl transition-transform duration-200">
          {open ? '−' : '+'}
        </span>
      </button>

      {/* Collapsible Answer Container */}
      {open && (
        <div className="px-6 sm:px-8 py-5 bg-gray-50/50 border-t border-gray-150">
          <p className="text-gray-700 text-base leading-relaxed">
            {answer}
          </p>
        </div>
      )}
    </div>
  );
}

export default FAQ;
